export default "__VITE_ASSET__CzJKJ2$P__"